import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, color: PropTypes.oneOf(['primary', 'secondary']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    color: 'primary',
};

class Progress extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            color,
        } = this.props;
        return [
            'c-progress',
            `c-progress--${color}`,
            className,
        ];
    }

}

Progress.propTypes = propTypes;

Progress.defaultProps = defaultProps;

export default Progress;
